import { Component, OnInit } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import {
  FormBuilder,
} from "@angular/forms";
import { PraticaScuola_Firestore } from "src/app/models/praticaScuolaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";


@Component({
  selector: "app-carica-file-altro-bando1",
  templateUrl: "./dialog-carica-altro.component.html",
  styleUrls: ["./pratiche-scuola-bando1.component.css"],
})
export class DialogCaricaFileAltroBando1 implements OnInit {
  protected _onDestroy = new Subject<void>();
  public pratica: PraticaScuola_Firestore;
  protected ref: DynamicDialogRef;
  selectedFile: File = null;
  isFileUploaded: boolean = false;
  isLoadingResults: boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _formBuilder: FormBuilder,
    private messageService: MessageService,
    public dialogService: DialogService,
    private googleStorageService: GoogleStorageService,
    ) {
   
  }

  ngOnInit(): void {
    this.pratica = this.config.data.pratica;
     
     }

  onFileUpload($event) {
    this.isFileUploaded = true;
    this.selectedFile = $event.files[0];
  }
  onFileRemove() {
    this.isFileUploaded = false;
  }
  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      const fileExtension = this.selectedFile.name.substring(
        this.selectedFile.name.lastIndexOf(".") + 1
      );
      const fileName = this.pratica.codiceInfratel + "/IN/ALTRO/" + this.selectedFile.name;
        this.googleStorageService
          .uploadFileScuolaToGoogleStorage(this.selectedFile, fileName)
          .then((uploadRes) => {
            this.dialogRef.close({ success: true, fileExtension: fileExtension });
          })
          .catch((errore) => {
            this.messageService.add({
              severity: "info",
            summary: "Errore" , life:10000,
              detail: "Errore in fase di caricamento File!",
            });

            this.dialogRef.close({ success: false });
          });
        this.logger.info();
      //let praticaDaModificare: PraticaScuola = new PraticaScuola();
      

      /* this.logger.info(praticaDaModificare);
       this.praticheScuolaService.richiediCambioCentrale(this.pratica.id.valueOf(), this.centrale).subscribe({
        next: (v) => {},
        error: (e) => {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail: "Errore in fase di COMUNICAZIONE CAMBIO CENTRALE della pratica",
          });
          this.dialogRef.close({ success: false });
        },
        complete: () => {
          this.dialogRef.close({ success: true });
        },
      });  */

      
    }
  }
}
